import { createFileRoute } from '@tanstack/react-router';

import { DrawingViewer } from '../../../features/drawings/drawing-viewer';

export const Route = createFileRoute('/drawings/view/$id')({
  staticData: {
    section: 'Production Planning',
    breadcrumb: 'Drawing',
    layout: 'full-height',
  },
  component: DrawingViewRoute,
});

function DrawingViewRoute() {
  const { id } = Route.useParams();
  return <DrawingViewer drawingId={id} />;
}
